module.exports = __webpack_public_path__ + "static/the-journey-of-crazy-horse-47322b0ae48e350b78100f2f12da99f2.jpg";